import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enTranslations },
            es: { translation: esTranslations }
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });

// Native platform detection enhancement
if (Capacitor.isNativePlatform()) {
    Device.getLanguageCode().then(({ value }) => {
        if (value) {
            const lang = value.split('-')[0];
            if (['en', 'es'].includes(lang)) {
                if (i18n.language !== lang) {
                    i18n.changeLanguage(lang);
                }
            } else if (i18n.language !== 'en') { // Fallback to English for unsupported languages
                i18n.changeLanguage('en');
            }
        }
    }).catch(err => console.warn('[i18n] Native detection failed:', err));
}

export default i18n;
